<template>
  <div class="success_" @click="clickSuceess">
    <img src="../assets/success.png" alt="success" />
    <div v-if="$route.query.type == 'modify'" class="text_ text_1">
      修改成功!<br />您的订单已提交成功，保险公司人员正在审核出单，预计1-2个工作日完成，请在已承保保单中查询进度</div>
    <div v-else class="text_ text_1">订单提交成功!</div>
    <div class="text_info">
      <div class="text_">订单号：{{ this.policyId }}</div>
    </div>
    <div class="rickTip" v-if="checkRiskUpload && JSON.stringify(checkRiskUpload) != '{}'">
      <div class="success-test" v-if="checkRiskUpload.riskNotifyFlag == '1'">
        投保成功，请到保单查看详情页面下载本保单的风险盖章函，回执页盖章上传。如不上传将影响保单后续事宜。
        <router-link to="/policyManage">去保单管理>>></router-link>
      </div>
    </div>
    <a href="#" ref="success"></a>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        policyId: '',
      };
    },
    computed: {
      checkRiskUpload() {
        let rickObj = JSON.parse(sessionStorage.getItem('checkRiskUpload'));
        console.log(rickObj);
        return rickObj;
      },
    },
    methods: {
      clickSuceess() {
        console.log('页面点击了')
      }
    },
    mounted() {
      const { policyId } = this.$route.query;
      this.policyId = policyId;
      this.$nextTick(() => {
        window.clairvoyanceRecord.save();
        this.$refs.success.click();
        let policyId = this.policyId.split(',') && this.policyId.split(',')[0];
        if (window.clairvoyanceRecord) {
          window.clairvoyanceRecord.finish({
            // oldPolicy: sessionStorage.getItem('oldPolicyId'),
            policyId: policyId
          });
          console.log('%cclairvoyanceRecordFinish == > 结束录制', 'color: green');
        } else {
          setTimeout(function () {
            if (window.clairvoyanceRecord) {
              window.clairvoyanceRecord.finish({
                policyId: policyId
              });
              console.log('%cclairvoyanceRecordFinish == > 结束录制', 'color: green');
            }
          }, 1000);
        }
      })
    },
  };
</script>

<style lang="scss" scoped>
  #app {
    min-height: 900px;
  }

  .success_ {
    padding-top: 132px;
    margin: 0 auto 0;
    min-width: 600px;
    width: 600px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    img {
      width: 228px;
      height: 186px;
    }

    .text_info {
      margin: 10px 0;
    }

    .text_ {
      font-size: 11px;
      font-family: Microsoft YaHei UI;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
    }

    .text_1 {
      font-size: 18px;
      font-weight: bold;
      color: rgba(254, 152, 69, 1);
      text-align: center;
    }

    .btn_list {
      display: flex;
      justify-content: center;

      .btn_ {
        margin: 19px;
        border: 1px solid rgba(254, 143, 45, 1);
        width: 150px;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        color: rgba(254, 143, 45, 1);

        .btn_a {
          color: inherit;
          flex: 1;
          text-align: center;
        }
      }

      .btn_:hover {
        color: #fff;
        background: rgba(254, 143, 45, 1);
      }
    }
  }

  .success-test {
    font-size: 16px;
    text-indent: 2em;
  }
</style>